import { useQueryClient } from "@tanstack/react-query";

import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { Requisition, RequisitionQueryParams } from "@/types";

export const useSetRequisition = () => {
  const queryClient = useQueryClient();
  const currentJobId = useCurrentJobId();

  return ({
    updatedRequisition,
    requisitionQueryParams,
  }: {
    updatedRequisition: Requisition;
    requisitionQueryParams: RequisitionQueryParams;
  }) => {
    queryClient.setQueryData(
      ["requisitions", currentJobId, requisitionQueryParams],
      (cachedRequisitions: Requisition[]) => {
        return cachedRequisitions.map((requisition) => {
          if (requisition.id === updatedRequisition.id) {
            return updatedRequisition;
          }
          return requisition;
        });
      },
    );
  };
};
